<h3>Clasificación</h3>
<div class="responsive-table">
    <table mat-table [dataSource]="dataSource" matSort (matSortChange)="announceSortChange($event)">
            <!-- Index Column -->
        <ng-container matColumnDef="index">
            <th mat-header-cell *matHeaderCellDef> # </th>
            <td mat-cell *matCellDef="let row; let i = index"> {{ i + 1 }} </td>
        </ng-container>
        
        <!-- Teams Column -->
        <ng-container matColumnDef="team">
            <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by team"></th>
            <td mat-cell *matCellDef="let element" (click)="openMatchDetail(element)"> 
                <div class="team-row" [ngClass]="{'small': isCompact}">
                    <img [src]="element.team.imgUrl" alt="{{element.team.name}} badge">
                    <span class="team-name">{{element.team.name}}</span>
                </div>
            </td>
        </ng-container>
        
        <!-- Matches Column -->
        <ng-container matColumnDef="matches">
            <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by matches">
            J
            </th>
            <td mat-cell *matCellDef="let element"> {{element.wins+element.draws+element.looses}} </td>
        </ng-container>
        
        <!-- Goals Column -->
        <ng-container matColumnDef="goals">
            <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by goals">
            GF
            </th>
            <td mat-cell *matCellDef="let element"> {{element.goals}} </td>
        </ng-container>

        <!-- Goals Against Column -->
        <ng-container matColumnDef="goals_against">
            <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by goals_against">
            GC
            </th>
            <td mat-cell *matCellDef="let element"> {{element.goals_against}} </td>
        </ng-container>

        <!-- Goals Difference Column -->
        <ng-container matColumnDef="goals_difference">
            <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by goals_difference">
            DG
            </th>
            <td mat-cell *matCellDef="let element"> {{element.goals - element.goals_against}} </td>
        </ng-container>

        <!-- Points Column -->
        <ng-container matColumnDef="points">
            <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by points">
            PTS
            </th>
            <td mat-cell *matCellDef="let element"> <strong>{{element.points}}</strong> </td>
        </ng-container>
        
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
</div>